import { Suspense } from 'react'
import { HeaderFilterContent } from '../Filter'
import { useFiltersLayout } from '../FiltersLayoutContext'
import { Skeleton } from '@/components/shadcn/skeleton'

export function HeaderFilters({ isConfiguringLayout }: { isConfiguringLayout: boolean }) {
  const { pinnedFilters } = useFiltersLayout()
  const leftFilters = pinnedFilters.filter((f) => f.pinned === 'left')
  const rightFilters = pinnedFilters.filter((f) => f.pinned === 'right')

  return (
    <Suspense fallback={<HeadeFiltersLoading />}>
      <div className="flex flex-1 flex-wrap items-center justify-between gap-2">
        <div className="flex gap-2">
          {!!leftFilters.length && (
            <HeaderFilterContent pinnedFilters={leftFilters} isConfiguringLayout={isConfiguringLayout} />
          )}
        </div>
        <div className="flex gap-2">
          {!!rightFilters.length && (
            <HeaderFilterContent pinnedFilters={rightFilters} isConfiguringLayout={isConfiguringLayout} />
          )}
        </div>
      </div>
    </Suspense>
  )
}

function HeadeFiltersLoading() {
  return (
    <div className="flex flex-1 flex-wrap items-center justify-between gap-2">
      <div className="flex gap-2">
        <Skeleton className="h-6 w-[200px]" />
        <Skeleton className="h-6 w-[200px]" />
      </div>
      <div className="flex gap-2">
        <Skeleton className="h-6 w-[200px]" />
        <Skeleton className="h-6 w-[200px]" />
      </div>
    </div>
  )
}
